/* eslint-disable react/prop-types */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { Dropdown, Overlay, Tooltip } from 'react-bootstrap';
import useBreakpoint from '../../hooks/useBreakpoint';
import { useClickOutside } from '../../hooks/useClickOutside';
import Icon from '../icon/Icon';
var MeatballDropdown = function(param, ref) {
    var children = param.children, className = param.className, disabled = param.disabled, btnClassName = param.btnClassName, toggleText = param.toggleText, tooltipProps = param.tooltipProps, onOpen = param.onOpen, _param_align = param.align, align = _param_align === void 0 ? 'right' : _param_align, _param_variant = param.variant, variant = _param_variant === void 0 ? 'outline-primary' : _param_variant, _param_closeDropdownOnSelect = param.closeDropdownOnSelect, closeDropdownOnSelect = _param_closeDropdownOnSelect === void 0 ? true : _param_closeDropdownOnSelect;
    var target = useRef();
    var isEnabledForBreakpoint = useBreakpoint([
        'md',
        'lg',
        'xl'
    ]);
    var _useState = _sliced_to_array(useState(false), 2), isTooltipVisible = _useState[0], setIsTooltipVisible = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isOpen = _useState1[0], setIsOpen = _useState1[1];
    var enableTooltip = !isEmpty(tooltipProps) && isEnabledForBreakpoint;
    var handleToggle = function(nextIsOpen, event) {
        var isDownloadMenu = event.target.hasAttribute('download');
        // don't close on select of a dropdown menu
        if (!closeDropdownOnSelect && isDownloadMenu) {
            return;
        }
        var isDropdownItemClicked = event.currentTarget.classList && event.currentTarget.classList.contains('dropdown-item');
        var isSubmenuDropClicked = isDropdownItemClicked && event.currentTarget.classList.contains('SubmenuButton');
        // don't close dropdown when Submenu trigger is clicked
        if (isSubmenuDropClicked) {
            return;
        }
        if (isDropdownItemClicked && !closeDropdownOnSelect) {
            return;
        }
        setIsOpen(nextIsOpen);
    };
    useEffect(function() {
        if (isOpen && onOpen) {
            onOpen();
        }
    }, [
        isOpen
    ]);
    useClickOutside(ref, function(event) {
        if (event.button === 2) {
            // right-click
            setIsOpen(false);
        }
    }, [], !isOpen);
    var _tooltipProps_placement;
    var _obj;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dropdown, {
        show: isOpen,
        bsPrefix: "MeatballDropdown",
        onToggle: handleToggle,
        ref: ref,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        ref: target,
        onBlur: function() {
            return enableTooltip && setIsTooltipVisible(false);
        },
        onMouseEnter: function() {
            return enableTooltip && setIsTooltipVisible(true);
        },
        onMouseLeave: function() {
            return enableTooltip && setIsTooltipVisible(false);
        },
        className: "ToggleContainer",
        disabled: disabled
    }, /*#__PURE__*/ React.createElement(Dropdown.Toggle, {
        disabled: disabled,
        variant: variant,
        bsPrefix: classnames('Toggle', (_obj = {}, _define_property(_obj, btnClassName, btnClassName), _define_property(_obj, "simple", !btnClassName), _obj))
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "more"
    }), toggleText ? /*#__PURE__*/ React.createElement("p", {
        className: "m-0 ml-2"
    }, toggleText) : null)), /*#__PURE__*/ React.createElement(Dropdown.Menu, {
        align: align
    }, children)), enableTooltip ? /*#__PURE__*/ React.createElement(Overlay, {
        placement: (_tooltipProps_placement = tooltipProps.placement) !== null && _tooltipProps_placement !== void 0 ? _tooltipProps_placement : 'bottom',
        target: target.current,
        show: isTooltipVisible
    }, function(props) {
        return /*#__PURE__*/ React.createElement(Tooltip, _object_spread({
            id: "meatballdropdown-tooltip"
        }, props), tooltipProps.text);
    }) : null);
};
export default /*#__PURE__*/ forwardRef(MeatballDropdown);
